<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      v-model="tabs.displayType.tabIndex"
      class="mb-4"
      @activate-tab="changeDisplayTypeTabs"
    >
      <b-tab
        v-for="(item, index) in tabs.displayType.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <div class="d-flex mb-4">
      <b-form-input
        class="mr-sm-2 mb-sm-0 w-25"
        placeholder="業務編號"
        v-model="search.number"
        @keyup.enter="getSalesTree(tabs.displayType.tabIndex)" />

      <b-form-input
        v-if="tabs.displayType.tabIndex === 2"
        class="mr-sm-2 mb-sm-0 w-25"
        placeholder="聘階"
        v-model="search.rank"
        @keyup.enter="getSalesTree(tabs.displayType.tabIndex)" />

      <b-button variant="primary" @click="getSalesTree(tabs.displayType.tabIndex)">查詢</b-button>
    </div>

    <section>
      <b-tabs
        v-model="tabs.upperLower.tabIndex"
        pills
        class="mb-4"
      >
        <b-tab
          v-for="(item, index) in visibleUpperLowerTabs"
          :key="index"
          :title="item.label"
          @click="changeUpperLowerTabs(item.apiName)"
        />
      </b-tabs>

      <b-form-checkbox
        v-if="tabs.displayType.tabIndex !== 2"
        class="mb-4"
        switch
        size="lg"
        v-model="status.allToggleExpand"
      >
        全部階層開關
      </b-form-checkbox>

      <ul v-if="tabs.displayType.tabIndex === 0" id="root">
        <tree-list
          :tree="tree"
        ></tree-list>
      </ul>

      <vue2-org-tree
        v-else-if="tabs.displayType.tabIndex === 1"
        :data="tree"
        :horizontal="true"
        collapsable
        @on-expand="onExpand" />

      <tables-page
        v-else-if="tabs.displayType.tabIndex === 2"
        :tableData="table_data"
        :tableFields="table_fields"
      >
        <template #cell(generations)="row">
          第{{ row.item.generations }}代
        </template>

        <template #cell(latest_reports)="row">
          {{ convertRocDate(row.item.new_member_join_date) }} {{ row.item.new_member_number }} {{ row.item.new_member_name }}
        </template>
      </tables-page>
    </section>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import businessApi from "@/models/API/businessApi";
import TreeList from './components/common/TreeList.vue';
import { convertRocDate } from "@/models/HELPERS/common.js";
import TablesPage from "@/components/layouts/TablesPage";

export default {
  name: 'businessOrganizationTree',
  components: {
    BreadCrumb,
    TreeList,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '業務管理', url: '', isActive: true },
          { name: '業務組織樹', url: '', isActive: false }
        ]
      },
      status: {
        allToggleExpand: true
      },
      tabs: {
        displayType: {
          items: [
            {
              label: '列表型組織',
              value: 0
            },
            {
              label: '樹狀型組織',
              value: 1
            },
            {
              label: '表格型組織',
              value: 2
            },
          ],
          tabIndex: 0
        },
        upperLower: {
          items: [
            {
              label: '上層',
              value: 0,
              apiName: 'getSalesUpperTree',
              disabled: false
            },
            {
              label: '下層',
              value: 1,
              apiName: 'getSalesLowerTree',
              disabled: false
            },
          ],
          tabIndex: 0
        }
      },
      search: {
        number: '',
        rank: ''
      },
      tree: {},
      // tree: {
      //   id: 0,
      //   label: "XXX科技有限公司",
      //   children: [
      //     {
      //       id: 2,
      //       label: "产品研发部",
      //       children: [
      //         {
      //           id: 5,
      //           label: "研发-前端"
      //         },
      //         {
      //           id: 6,
      //           label: "研发-后端"
      //         },
      //         {
      //           id: 9,
      //           label: "UI设计"
      //         },
      //         {
      //           id: 10,
      //           label: "产品经理"
      //         }
      //       ]
      //     },
      //     {
      //       id: 3,
      //       label: "销售部",
      //       children: [
      //         {
      //           id: 7,
      //           label: "销售一部"
      //         },
      //         {
      //           id: 8,
      //           label: "销售二部"
      //         }
      //       ]
      //     },
      //     {
      //       id: 4,
      //       label: "财务部"
      //     },
      //     {
      //       id: 9,
      //       label: "HR人事"
      //     }
      //   ]
      // },
      table_fields: [
        {
          key: "generations",
          label: "代數",
        },
        {
          key: "number",
          label: "編號",
        },
        {
          key: "name",
          label: "姓名",
        },
        {
          key: "rank",
          label: "聘階",
        },
        {
          key: "latest_reports",
          label: "最新報件",
        },
        {
          key: "sales_count",
          label: "業務",
        },
        {
          key: "valid_count",
          label: "直推"
        },
        {
          key: "system_valid_count",
          label: "體系有效件"
        },
        {
          key: "team_valid_count",
          label: "團隊有效件"
        },
        {
          key: "unpay",
          label: "直推未繳"
        }
      ],
      table_data: [],
    }
  },
  // 在路由離開前觸發邏輯
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("businessNumber");

    next();
  },
  computed: {
    visibleUpperLowerTabs() {
      return this.tabs.upperLower.items.filter(item => !item.disabled);
    }
  },
  watch: {
    'status.allToggleExpand': {
      handler(newValue, oldValue) {
        this.toggleExpand(this.tree, newValue);
      },
      immediate: false
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.load();
  },
  methods: {
    convertRocDate,
    // 首次載入讀取
    load() {
      const businessNumber = sessionStorage.getItem("businessNumber") || null;

      if (businessNumber) {
        this.search = JSON.parse(businessNumber);

        this.getSalesTree();
      }
    },
    // 改變顯示方式tab 時觸發
    changeDisplayTypeTabs(newTabIndex, prevTabIndex, bvEvent) {
      if (newTabIndex === 2) {
        this.tabs.upperLower.items[0].disabled = true;
        this.tabs.upperLower.tabIndex = 1;

        if (this.search.number !== '') this.getSalesTree(newTabIndex);
      } else {
        this.tabs.upperLower.items[0].disabled = false;

        if (this.search.number !== '' && prevTabIndex === 2) this.getSalesTree(newTabIndex);
      }
    },
    // 改變上下層tab 時觸發
    changeUpperLowerTabs(api_name) {
      if (this.search.number !== '')  this.getSalesTree(this.tabs.displayType.tabIndex, api_name);
    },
    // 查詢業務組織樹(上下層)
    getSalesTree(displayType_tabIndex = 0, api_name) {
      const params = {
        ...this.search,
        'flat': displayType_tabIndex === 2 ? 1 : 0
      };

      // const fun = this.tabs.upperLower.items.find(item => item.value === this.tabs.upperLower.tabIndex).apiName;
      const fun = api_name ? api_name : this.tabs.upperLower.items.find(item => item.value === this.tabs.upperLower.tabIndex).apiName;

      this.businessApi[fun]((response) => {
        const res = response.data;

        this.table_data = [];

        if (res.data.length > 0) {
          if (displayType_tabIndex === 2) {
            this.table_data = res.data;
          } else {
            this.tree = res.data[0];

            this.addLabelToTree(this.tree);
          }
        }
      }, params)
    },
    addLabelToTree(tree) {
      const startTime = performance.now();
      const queue = [tree];
      const isUpper = this.tabs.upperLower.tabIndex === 0;

      while (queue.length > 0) {
        const node = queue.shift();

        if (isUpper) {
          node.label = `第${node.generations}代 - ${node.name}(${node.number}：${node.rank})`;
        } else {
          const is_new_member = node.new_member_join_date && node.new_member_number && node.new_member_name ? true : false;

          node.label =
            `第${node.generations}代-${node.number}(${node.name}：${node.rank})
            ${is_new_member ? `　最新報件：${convertRocDate(node.new_member_join_date)} ${node.new_member_number} ${node.new_member_name}` : ''}
            　業務：${node.sales_count} 直推：${node.valid_count}
            　體系有效件：${node.system_valid_count}
            　團隊有效件：${node.team_valid_count}
            　直推未繳：${node.unpay}
            `;
        }

        if (node.children && node.children.length > 0) {
          for (let i = 0; i < node.children.length; i++) {
            const child = node.children[i];

            if (isUpper) {
              child.label = `第${child.generations}代 - ${child.name}(${child.number}：${child.rank})`;
            } else {
              const is_new_member = child.new_member_join_date && child.new_member_number && child.new_member_name ? true : false;

              child.label =
                `第${child.generations}代-${child.number}(${child.name}：${child.rank})
                ${is_new_member ? `　最新報件：${convertRocDate(child.new_member_join_date)} ${child.new_member_number} ${child.new_member_name}` : ''}
                　業務：${child.sales_count} 直推：${child.valid_count}
                　體系有效件：${child.system_valid_count}
                　團隊有效件：${child.team_valid_count}
                　直推未繳：${child.unpay}
                `;
            }

            queue.push(child);
          }
        }
      }

      const endTime = performance.now();
      const executionTimeMs = endTime - startTime;
      const executionTimeSec = executionTimeMs / 1000;
      console.log("addLabelToTree 執行時間：", executionTimeSec, "秒");
      // console.log( this.tree);

      this.toggleExpand(this.tree, true);
    },
    // 樹狀圖全部展開
    toggleExpand(data, val) {
      const _this = this;

      if (Array.isArray(data)) {
          data.forEach(function(item) {
            _this.$set(item, "expand", val);
            if (item.children) {
              _this.toggleExpand(item.children, val);
            }
          });
      } else {
          this.$set(data, "expand", val);
          if (data.children) {
            _this.toggleExpand(data.children, val);
          }
      }
    },
    collapse(list) {
      const _this = this;

      list.forEach(function(child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
            this.collapse(data.children);
        }
      } else {
          this.$set(data, "expand", true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.floating{
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  transition: all 0.3s;
  z-index: 999;
  text-align: left;
  font-size: 16px;
}
/deep/ .org-tree-node-label .org-tree-node-label-inner {
  width: 15rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/businessOrganizationTree.vue